module.exports = __webpack_public_path__ + "static/media/2.020ce61d.jpg";